import React from 'react';
import FormInventoryConfigurationRuleDetail from '../../../sections/AdminDashboard/Configuration/FormInventoryRuleDetail';

const FormInventoryRuleDetail = () => <FormInventoryConfigurationRuleDetail />;

export default FormInventoryRuleDetail;
